import React from "react";
import styled from "styled-components";
import { string } from "prop-types";

import { color } from "./utils";

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 5px;
  box-shadow: 0 0 5px ${color("darkGrey")};
  background-color: ${color("white")};
  color: ${({ color }) => color};
  cursor: pointer;
  margin: 0.5rem;
`;

const MapButton = ({ ...props }) => <StyledButton {...props} />;

MapButton.propTypes = {
  color: string.isRequired,
};

export default MapButton;
